import React from 'react';

import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core';
import MuiTableHead, { TableHeadProps as MuiTableHeadProps } from '@material-ui/core/TableHead';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      '& th': {
        fontSize: theme.custom.fontSizes.tiny,
        fontWeight: 600,
        textTransform: 'uppercase',
      },
    },
  });

export interface TableHeadProps extends Omit<MuiTableHeadProps, 'classes'>, WithStyles<typeof styles> {
  noWrap?: boolean;
}

const TableHeadComponent: React.FC<TableHeadProps> = ({ classes, ...rest }) => (
  <MuiTableHead className={classes.root} {...rest} />
);

export const TableHead = withStyles(styles)(TableHeadComponent);
